import { Skeleton } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import { retrievePath, safeRedirectUrl, website } from '../../lib/iris';
import { initiateOmniauthFlow } from '../../lib/omniauth';
import Container from '../Container';
import Heading from '../Heading';

import SessionForm, { sessionForms } from './SessionForm';

const SessionPage: FC = () => {
  const [params] = useSearchParams();
  const { actorType } = useCurrentActor();
  const location = useLocation();
  const navigate = useNavigate();

  const form = sessionForms.find(({ path }) => location.pathname.startsWith(path));
  const redirectUrl = safeRedirectUrl(params.get('redirect_url')) || website;
  const redirectUser = redirectUrl && actorType === 'ConfirmedUser';
  const startOmniauthFlow = params.has('auto') && actorType === 'GuestUser' && !!GLOBALS.config.omniauthProvider;

  useEffect(() => {
    if (redirectUser) {
      navigate(retrievePath(redirectUrl)!, { replace: true });
    }
  }, [redirectUser]);

  useEffect(() => {
    if (startOmniauthFlow) {
      initiateOmniauthFlow();
    }
  }, [startOmniauthFlow]);

  if (redirectUser || !form || startOmniauthFlow) {
    return (
      <Container>
        <Heading>Inloggen</Heading>
        <Skeleton />
        <Skeleton width="60%" />
        <Skeleton width="80%" />
      </Container>
    );
  }

  return <SessionForm form={form} redirectUrl={redirectUrl} />;
};

export default SessionPage;
